import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { CONTACT, USER } from 'self-service-api/constants/UnitTypes';
import { useAppSelector } from '../../reducers';
import { currentSkuIdForProductSelector, isSalesOrServiceProOrEntSkuSelector, quantityPackForProductVersionSelector, skuSelector } from '../../selectors/ProductsSelectors';
import { usePricingLibSelector } from '../../selectors/SelectorUtils'; // Cannot be used with a sku with multiple quantityPacks

export const useSkuAdditionalUnits = ({
  productLevel,
  productLine
}) => {
  const skuId = useAppSelector(state => currentSkuIdForProductSelector(state, {
    productLine,
    productLevel
  }));
  const isSeatsUngated = usePricingLibSelector(getIsUngatedForSeats);
  const additionalUnitSkuId = useSelector(state => {
    if (!skuId) {
      return null;
    }

    const isSkuQuantifiable = skuSelector(state, {
      skuId
    }).quantifiable;

    if (isSalesOrServiceProOrEntSkuSelector(state, {
      skuId
    }) && isSkuQuantifiable && isSeatsUngated) {
      return skuId;
    } else {
      const quantityPack = quantityPackForProductVersionSelector(state, {
        productVersionSkuId: skuId,
        unitType: productLine === MARKETING ? CONTACT : USER,
        unitScope: productLine
      });
      return quantityPack && quantityPack.skuId || null;
    }
  });
  const isAdditionalUnitSkuIdAQuantityPack = useSelector(state => {
    if (!additionalUnitSkuId) {
      return false;
    }

    const {
      skuType
    } = skuSelector(state, {
      skuId: additionalUnitSkuId
    });
    return skuType === QUANTITY_PACK;
  });
  const [additionalUnitQuantity, setAdditionalUnitQuantity] = useState(0);
  return {
    additionalUnitSkuId,
    isAdditionalUnitSkuIdAQuantityPack,
    additionalUnitQuantity,
    setAdditionalUnitQuantity,
    skuId
  };
};